import { render, staticRenderFns } from "./PanelWorkType.vue?vue&type=template&id=79e17650&"
import script from "./PanelWorkType.vue?vue&type=script&lang=js&"
export * from "./PanelWorkType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports